import { render } from "./ModalSubmit.vue?vue&type=template&id=ab42bec6&scoped=true"
import script from "./ModalSubmit.vue?vue&type=script&lang=js"
export * from "./ModalSubmit.vue?vue&type=script&lang=js"

import "./ModalSubmit.vue?vue&type=style&index=0&id=ab42bec6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab42bec6"]])

export default __exports__